
import _ from 'lodash';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';


export const ServiceabilityValuesComponent = ({
  selectedServiceabilityValues,
  onInnerBasicFormChange,
  selectedServiceabilitys,
  onFormServiceabilityItemChange,
  categories,
  subCategories,
  products,
  productTypes,
  variants,
  pinCodes,
  getSubCategories
}: any) => {
  // const selectedServiceabilitys.PINCode: any = cardData.length > 0 ? JSON.parse(cardData) : []
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="PIN CODE"
              labelField="Code"
              list={pinCodes}
              onValueChange={(newValue: any) => {
                const pinCodeData: any = newValue.map((option: any) => option?.value || '')
                onInnerBasicFormChange(
                  pinCodeData,
                  'PINCode'
                )
              }}
              type="multiselect"
              valueField="Code"
              value={selectedServiceabilitys?.PINCode}
            />
          </div>
        }
        expandedPanel="servicability"
        headerTitle="Servicability Check"
      />
      {_.map(
        selectedServiceabilityValues,
        (selectedServiceabilityValue: any, index: any) => (
          <div className=" grid md:grid-cols-3 lg:grid-cols-4 gap-4 border p-4">
            <InputContainer

              label="Active"
              name="IsActive"
              onValueChange={(event: any) => {
                onFormServiceabilityItemChange({
                  value: event,
                  field: 'IsActive',
                  idx: index

                })
              }}
              type="checkbox"
              value={selectedServiceabilityValue?.IsActive}
            />

            <InputContainer
              label="Name"
              labelField="Name"
              onValueChange={(event: any, newValue: any) => {
                onFormServiceabilityItemChange({
                  value: event.target.value,
                  field: 'Name',
                  idx: index
                });
              }}
              type="text"
              value={selectedServiceabilityValue?.Name}

            />
            <InputContainer
              label="Product Type"
              labelField="Name"
              list={productTypes}
              onValueChange={(event: any, newValue: any) => {
                onFormServiceabilityItemChange({
                  value: event.target.value,
                  field: 'ProductTypeName',
                  idx: index
                });
              }}
              optionName='Choose ProductType'
              type="select"
              value={selectedServiceabilityValue?.ProductTypeName}
              valueField="Name"
            />
            <InputContainer
              label="Category"
              labelField="Name"
              list={categories}
              onValueChange={(event: any, newValue: any) => {
                getSubCategories(event.target.value)
                onFormServiceabilityItemChange({
                  value: event.target.value,
                  field: 'CategoryId',
                  idx: index
                });
              }}
              optionName='Choose Category'
              type="select"
              value={selectedServiceabilityValue?.CategoryId}
              valueField="Id"
            />

            <InputContainer
              label="SubCategory"
              labelField="Name"
              list={subCategories}
              onValueChange={(event: any, newValue: any) => {
                onFormServiceabilityItemChange({
                  value: event.target.value,
                  field: 'SubCategoryName',
                  idx: index
                });
              }}
              optionName='Choose SubCategory'
              type="select"
              value={selectedServiceabilityValue?.SubCategoryName}
              valueField="Name"
            />
            <InputContainer
              label="Product"
              labelField="Name"
              list={products}
              onValueChange={(event: any, newValue: any) => {
                onFormServiceabilityItemChange({
                  value: event.target.value,
                  field: 'ProductName',
                  idx: index
                });
              }}
              optionName='Choose ProductName'
              type="select"
              value={selectedServiceabilityValue?.ProductName}
              valueField="Name"
            />


            <InputContainer
              label="Variant"
              labelField="Name"
              list={variants}
              onValueChange={(event: any, newValue: any) => {
                onFormServiceabilityItemChange({
                  value: event.target.value,
                  field: 'VariantName',
                  idx: index
                });
              }}
              optionName='Choose Variant'
              type="select"
              value={selectedServiceabilityValue?.VariantName}
              valueField="Name"
            />

            <InputContainer

              label="Delivery Hub Enabled"
              name="IsActive"
              onValueChange={(event: any) => {
                onFormServiceabilityItemChange({
                  value: event,
                  field: 'IsDeliveryHubEnabled',
                  idx: index
                })
              }}
              type="checkbox"
              value={selectedServiceabilityValue?.IsDeliveryHubEnabled}
            />
          </div>
        ),
      )}
    </>
  )
}
export default ServiceabilityValuesComponent;
